import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot from react-dom/client
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializePostHog } from "./utils/posthog";

// Initialize Sentry before anything else renders
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
  });
}

// Always initialize PostHog with memory persistence (no cookies).
// Tracks conversions before consent; upgrades to cookie when user accepts.
if (process.env.NODE_ENV === 'production' || localStorage.getItem('testPostHog') === 'true') {
  initializePostHog();
}

// Testing: set fast dot from console anytime (e.g. __fastDotForTesting() or __fastDotForTesting(30))
// Uses two underscores: __fastDotForTesting
if (typeof window !== "undefined") {
  window.__fastDotForTesting = function (ms) {
    window.__PENDING_FAST_DOT = typeof ms === "number" ? ms : 50;
  };
  window.__setDotSpeed = null; // App will replace with real setter when mounted
}

// Find the root container element
const container = document.getElementById("root");
// Create a root
const root = createRoot(container);
// Initial render: render the App component to the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// For performance measurements
reportWebVitals();
